import { useParams } from 'react-router-dom'
import { Box, Container, Grid, Paper, ThemeProvider, Toolbar, Typography, useMediaQuery } from '@mui/material'
import { useEffect, useState } from 'react'
import gaiaLogo from '../../../assets/corporate-logos/gaia/gaia-logo.png'
import gaiaTheme from '../../../root-components/theme'
import ProjectReportsService from '../shared-services/project-reports.service'
import type { IProjectReportWebpageData } from '../shared-services/project-reports.model'
import { ProjectReportWebPage } from '../components/project-report-web-page'

export const PublicProjectReportPage = () => {
  const { id } = useParams()
  const projectReportsService = new ProjectReportsService()
  const [report, setReport] = useState<IProjectReportWebpageData>()
  const [error, setError] = useState(false)
  const [errorCode, setErrorCode] = useState<number>()
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'))

  useEffect(() => {
    if (id) {
      projectReportsService.getPublicWebpage(id)
        .then(setReport)
        .catch(err => {
          setError(true)
          setErrorCode(err?.response?.data?.code === 1 ? 1 : 2)
          console.log(err)
        })
    }
  }, [id])

  const errorBox = (message: string) => (
    <ThemeProvider theme={gaiaTheme}>
      <Box style={{ backgroundColor: '#F0F1F3', minHeight: '100vh' }}>
        <Toolbar />
        <Container maxWidth='sm' sx={{ mt: 4, mb: 4 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <img src={gaiaLogo} alt='GAIA logo' height='70' style={{ verticalAlign: 'middle', paddingLeft: '45px', paddingBottom: '15px' }} />
              <Paper variant='outlined' sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ width: '90%', p: '24px' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant='h5'>Error</Typography>
                    </Grid>
                    <Box component='form' noValidate autoComplete='off' sx={{ width: '100%', ml: isMobileMode ? 0 : 2 }}>
                      <Typography sx={{ pt: 2 }}>{message}</Typography>
                    </Box>
                  </Grid>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </ThemeProvider>
  )

  if (error && errorCode === 1) {
    return errorBox('This webpage is no longer available. The link has been disabled.')
  }
  if (error) {
    return errorBox('There has been an error loading this webpage, please try again.')
  }

  return (
    <>
      {report && <ProjectReportWebPage report={report} />}
    </>
  )
}
